import {
  CREATE_CHAT_REQUEST,
  CREATE_CHAT_SUCCESS,
  CREATE_CHAT_FAILURE,
  GET_CHAT_BETWEEN_USERS_REQUEST,
  GET_CHAT_BETWEEN_USERS_SUCCESS,
  GET_CHAT_BETWEEN_USERS_FAILURE,
} from "../actions/types";

const initialState = {
  chat: null,
  loading: false,
  error: null,
  unreadCount: 0,
};

const chatReducer = (state = initialState, action) => {
  switch (action.type) {
    // Create Chat
    case CREATE_CHAT_REQUEST:
      return { ...state, loading: true, error: null };
    case CREATE_CHAT_SUCCESS:
      return { ...state, loading: false, chat: action.payload };
    case CREATE_CHAT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Get Chat Between Users
    case GET_CHAT_BETWEEN_USERS_REQUEST:
      return { ...state, loading: true, error: null };
    case GET_CHAT_BETWEEN_USERS_SUCCESS:
      return { ...state, loading: false, chat: action.payload }; case GET_CHAT_BETWEEN_USERS_SUCCESS:
      const messages = action.payload.messages || [];
      const unreadCount = messages.filter(msg => !msg.read && msg.receiver_id === currentUserId).length;
      return {
        ...state,
        loading: false,
        chat: action.payload,
        unreadCount,
      };
    case GET_CHAT_BETWEEN_USERS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default chatReducer;
